import getAdPlaying from "selectors/ads/getAdPlaying";
import { createSelector } from "reselect";

const getShowAdControls = createSelector(
  [getAdPlaying],
  (adPlaying) => adPlaying,
);

export default getShowAdControls;
